/* eslint-disable no-console */

import * as Sentry from '@sentry/vue'
import OpenAIApi from '@/api/openai'

const _state = {
}

const getters = {
}

const actions = {
  async stressTestOpenEndedAnswers(_, payload) {
    try {
      await OpenAIApi.stressTestOpenEndedAnswers(payload)
    } catch (error) {
      Sentry.captureException(`stressTestOpenEnded error: ${error}`)
    }
  },
}

const mutations = {
}

const openAI = {
  namespaced: true,
  state: _state,
  getters,
  actions,
  mutations,
}

export default openAI
